import {AfterViewInit, Component, DestroyRef, inject, OnInit, ViewChild} from '@angular/core';
import {InputComponent} from "@app/input/input.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DataService} from "@app/shared/data.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "@app/toast/toast.service";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {catchError, forkJoin, fromEvent, of, switchMap, tap} from "rxjs";
import {debounceTime, map} from "rxjs/operators";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {
  QuarantinePlacementFooterComponent
} from "@app/quarantine/shared/quarantine-placement-footer/quarantine-placement-footer.component";
import {ErrorModule} from "@app/error/error.module";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {PersonalOfferInterface, RedistributionRequestInterface} from "@app/redistribution/redistribution.interface";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";
import {
  PersonalOfferStatusComponent
} from "@app/redistribution/shared/personal-offer-status/personal-offer-status.component";
import {MedIconResetModule} from "@mk/med-icons";
import {MedPaginationModule} from "@med-ui/med-pagination/med-pagination.module";
import {
  ModalPutPersonalProposalComponent
} from "@app/redistribution/modals/modal-put-personal-proposal/modal-put-personal-proposal.component";
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";
import {
  ModalManagePersonalProposalComponent
} from "@app/redistribution/modals/modal-manage-personal-proposal/modal-manage-personal-proposal.component";
import {
  ModalRejectPersonalProposalComponent
} from "@app/redistribution/modals/modal-reject-personal-proposal/modal-reject-personal-proposal.component";
import {
  ModalCancelPersonalProposalComponent
} from "@app/redistribution/modals/modal-cancel-personal-proposal/modal-cancel-personal-proposal.component";
import {
  ModalCancelRedistributionRequestComponent
} from "@app/redistribution/modals/modal-cancel-redistribution-request/modal-cancel-redistribution-request.component";

@Component({
  selector: 'app-redistribution-request-details',
  templateUrl: './redistribution-request-details.component.html',
  styleUrls: ['./redistribution-request-details.component.scss'],
  standalone: true,
  imports: [
    LoadingAnimationComponent,
    QuarantinePlacementFooterComponent,
    ErrorModule,
    NgIf,
    RedistributionStatusComponent,
    NgForOf,
    PersonalOfferStatusComponent,
    MedIconResetModule,
    MedPaginationModule,
    ModalPutPersonalProposalComponent,
    ModalManagePersonalProposalComponent,
    ModalRejectPersonalProposalComponent,
    DatePipe,
    ModalCancelPersonalProposalComponent,
    ModalCancelRedistributionRequestComponent,
  ]
})
export class RedistributionRequestDetailsComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  
  @ViewChild(ModalPutPersonalProposalComponent) modalPutPersonalProposal!: ModalPutPersonalProposalComponent;
  @ViewChild(ModalManagePersonalProposalComponent) modalManagePersonalProposal!: ModalManagePersonalProposalComponent;
  @ViewChild(ModalRejectPersonalProposalComponent) modalRejectPersonalProposal!: ModalRejectPersonalProposalComponent;
  @ViewChild(ModalCancelPersonalProposalComponent) modalCancelPersonalProposal!: ModalRejectPersonalProposalComponent;
  @ViewChild(ModalCancelRedistributionRequestComponent) modalCancelRedistributionRequest!: ModalRejectPersonalProposalComponent;
  
  isLoading = false;
  
  redistributionRequest!: RedistributionRequestInterface;
  personalOfferings: Array<PersonalOfferInterface>= [];
  
  activeOffering!: PersonalOfferInterface;
  
  allOrganizations: any[] = [];
  
  pagination = {
    page: 1,
    perPage: 20,
    totalPages: 0,
    totalElements: 0
  }
  
  constructor(
      private fb: FormBuilder,
      private dataService: DataService,
      private router: Router,
      private toastService: ToastService,
      private redistributionApiService: RedistributionApiService,
      private activatedRoute: ActivatedRoute,
  ) {
  }
  
  
  ngOnInit() {
    let breadcrumbs = [...this.activatedRoute.snapshot.data['breadcrumbs']]
    breadcrumbs.push({title: 'Створити запит на перерозподіл', link: ''});
    this.dataService.breadcrumbsArray.next(breadcrumbs);
    
    this.dataService.allOrganizationsValue.subscribe((value) => {
      let res = [];
      let stash = [...value.data];
      
      while (stash.length > 0) {
        let el = stash.pop();
        res.push(el);
        if (el.children.length > 0) {
          stash.push(...el.children);
        }
      }
      
      
      this.allOrganizations = res;
    })
    
    this.getData();
  }
  
  getData() {
    this.isLoading = true;
    
    forkJoin({
      redistributionRequest: this.redistributionApiService.getRedistributionRequest(Number(this.activatedRoute.snapshot.params['id'])),
      personalOfferings: this.redistributionApiService
          .getRedistributionRequestPersonalOfferings(
              Number(this.activatedRoute.snapshot.params['id']),
              {page:  this.pagination.page - 1, size: this.pagination.perPage}),
      
    }).subscribe((data) => {
      this.redistributionRequest = data.redistributionRequest;
      this.personalOfferings = data.personalOfferings['content'];
      this.isLoading = false;
    })
  }
  
  getOrganisationName(id: number) {
    return this.allOrganizations.find(el => el.id === id)?.fullName || id;
  }
  
  returnToList() {
    this.router.navigate(['redistributions/requests']);
  }
  
  onOpenModalManagePersonalProposal(offering: PersonalOfferInterface) {
    this.activeOffering = offering;
    this.modalManagePersonalProposal.open();
  }
  
  onPageChange(page: number) {
    this.pagination.page = page;
    this.getData();
  }
  
  openModalPutPersonalProposal() {
    this.modalPutPersonalProposal.open();
  }
  
  onReject() {
    this.modalRejectPersonalProposal.open();
  }
  
  onCancel() {
    this.modalCancelPersonalProposal.open();
  }
  
  onCancelRedistributionRequest() {
    this.modalCancelRedistributionRequest.open();
  }
  
  get isActiveRequest() {
    return this.redistributionRequest && this.redistributionRequest.status === 'ACTIVE';
  }
  
  get canCancelRequest() {
    return this.redistributionRequest && this.dataService.userOrganizationsValue.value.find(el => el['id'] === this.redistributionRequest.organizationId) !== undefined;
  }
  
}
